var _style, _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWikimediaFoundation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 613.7 458.5",
    style: {
      enableBackground: "new 0 0 613.7 458.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{display:none;}\n\t.st1{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M56,338l11.9-38.6h15.6L95.3,338l13.3-38.6h16.2l-23.4,67.1H90.3l-14.7-46.7l-14.6,46.7H49.9l-23.4-67.1h16.2L56,338z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.9,299.4h15v67.1h-15V299.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.4,299.4h15V327l25.3-27.6h18.5l-26.7,29.7c2.3,3.2,6.6,9.2,12.8,17.9c6.2,8.7,10.8,15.2,13.9,19.5h-17.5L186.1,340 l-6.7,7.5v19h-15V299.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.5,299.4h15v67.1h-15V299.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.1,324.3L306,361H297l-18-36.7v42.2h-15v-67.1h20.3l17.3,36.9l17.4-36.9h20.2v67.1h-15V324.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M404,299.4v13.3h-33.4v13.8h30v12.8h-30v13.9H405v13.2h-49.4v-67.1H404z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.6,308.2c6.4,5.9,9.6,14,9.6,24.4c0,10.4-3.1,18.7-9.4,24.8c-6.2,6.1-15.8,9.1-28.6,9.1h-22.9v-67.1h23.7 C454.1,299.4,463.2,302.4,469.6,308.2z M458.6,348.1c3.7-3.5,5.5-8.5,5.5-15.1c0-6.6-1.8-11.7-5.5-15.2c-3.7-3.6-9.3-5.3-16.9-5.3 h-8.4v40.8h9.5C449.7,353.3,455,351.6,458.6,348.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.2,299.4h15v67.1h-15V299.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M571.5,366.5l-6.2-14.5h-28.1l-6.2,14.5h-15.9l29-67.1h14.5l29,67.1H571.5z M551.2,319.4l-8.4,19.5h16.8L551.2,319.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.3,407v7.7h12.4v4.4H92.3v11.5h-4.7v-28h18.6l0,4.4H92.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.1,426.7c-2.8,2.8-6.3,4.1-10.5,4.1s-7.7-1.4-10.5-4.1c-2.8-2.8-4.2-6.2-4.2-10.3s1.4-7.6,4.2-10.3 c2.8-2.8,6.3-4.1,10.5-4.1s7.7,1.4,10.5,4.1c2.8,2.8,4.2,6.2,4.2,10.3S156,423.9,153.1,426.7z M149.7,409.2c-1.9-2-4.2-3-7-3 s-5.1,1-7,3c-1.9,2-2.9,4.4-2.9,7.2s1,5.2,2.9,7.2c1.9,2,4.2,3,7,3s5.1-1,7-3c1.9-2,2.9-4.4,2.9-7.2S151.6,411.1,149.7,409.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.6,424.1c1.3,1.5,3,2.2,5.2,2.2c2.2,0,3.9-0.7,5.2-2.2c1.3-1.5,1.9-3.5,1.9-6.1v-15.5h4.7v15.7c0,4-1.1,7.1-3.3,9.3 c-2.2,2.2-5.1,3.3-8.5,3.3c-3.5,0-6.3-1.1-8.5-3.3c-2.2-2.2-3.3-5.3-3.3-9.3v-15.7h4.7v15.5C185.7,420.6,186.3,422.6,187.6,424.1z "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251,402.6h4.7v28h-5.1l-15.8-20.4v20.4h-4.7v-28h4.7l16.2,20.9V402.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.6,406.2c2.7,2.4,4,5.8,4,10.2c0,4.3-1.3,7.8-3.9,10.3c-2.6,2.5-6.6,3.8-12,3.8h-9.3v-28h9.6 C296.1,402.6,300,403.8,302.6,406.2z M301.9,416.5c0-6.4-3.7-9.6-11-9.6h-4.7v19.2h5.2c3.4,0,6-0.8,7.8-2.4 C301,422.1,301.9,419.7,301.9,416.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.7,424.2l-2.8,6.4h-5l12.3-28h5l12.3,28h-5l-2.8-6.4H334.7z M346.8,419.8l-5.1-11.5l-5.1,11.5H346.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.8,406.9v23.6h-4.7v-23.6h-8.5v-4.3h21.7v4.3H386.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.4,402.6h4.7v28h-4.7V402.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.3,426.7c-2.8,2.8-6.3,4.1-10.5,4.1s-7.7-1.4-10.5-4.1c-2.8-2.8-4.2-6.2-4.2-10.3s1.4-7.6,4.2-10.3s6.3-4.1,10.5-4.1 s7.7,1.4,10.5,4.1c2.8,2.8,4.2,6.2,4.2,10.3S475.1,423.9,472.3,426.7z M468.8,409.2c-1.9-2-4.2-3-7-3s-5.1,1-7,3 c-1.9,2-2.9,4.4-2.9,7.2s1,5.2,2.9,7.2c1.9,2,4.2,3,7,3s5.1-1,7-3c1.9-2,2.9-4.4,2.9-7.2S470.7,411.1,468.8,409.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M521.4,402.6h4.7v28H521l-15.8-20.4v20.4h-4.7v-28h4.7l16.2,20.9V402.6z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M317.3,216c35.9-5.1,63.5-35.9,63.5-73.3c0-22.7-10.2-43-26.3-56.5l-37.3,37.3V216z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M296.4,216v-92.5l-37.3-37.3c-16.1,13.6-26.3,33.9-26.3,56.5C232.9,180,260.5,210.9,296.4,216z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M371.2,78.4c17.2,17.2,26.6,40,26.6,64.3s-9.5,47.1-26.6,64.3c-17.2,17.2-40,26.6-64.3,26.6 c-24.3,0-47.1-9.5-64.3-26.6s-26.6-40-26.6-64.3c0-24.3,9.5-47.1,26.6-64.3c1.5-1.5,3-2.9,4.5-4.2l-20.8-20.8 c-1.5,1.4-3,2.8-4.5,4.3c-11,11-19.7,23.9-25.8,38.2c-6.3,14.8-9.5,30.6-9.5,46.8c0,16.2,3.2,32,9.5,46.8 c6.1,14.3,14.7,27.2,25.8,38.2c11,11,23.9,19.7,38.2,25.8c14.8,6.3,30.6,9.5,46.8,9.5c16.2,0,32-3.2,46.8-9.5 c14.3-6.1,27.2-14.7,38.2-25.8c11-11,19.7-23.9,25.8-38.2c6.3-14.8,9.5-30.6,9.5-46.8c0-16.2-3.2-32-9.5-46.8 c-6.1-14.3-14.7-27.2-25.8-38.2c-1.5-1.5-3-2.9-4.5-4.3l-20.8,20.8C368.2,75.5,369.7,76.9,371.2,78.4z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "red_circle_52_",
    className: "st1",
    cx: 306.9,
    cy: 59.3,
    r: 37.5
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M317.3,216c35.9-5.1,63.5-35.9,63.5-73.3c0-22.7-10.2-43-26.3-56.5l-37.3,37.3V216z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.4,216v-92.5l-37.3-37.3c-16.1,13.6-26.3,33.9-26.3,56.5C232.9,180,260.5,210.9,296.4,216z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.2,78.4c17.2,17.2,26.6,40,26.6,64.3s-9.5,47.1-26.6,64.3c-17.2,17.2-40,26.6-64.3,26.6c-24.3,0-47.1-9.5-64.3-26.6 s-26.6-40-26.6-64.3c0-24.3,9.5-47.1,26.6-64.3c1.5-1.5,3-2.9,4.5-4.2l-20.8-20.8c-1.5,1.4-3,2.8-4.5,4.3 c-11,11-19.7,23.9-25.8,38.2c-6.3,14.8-9.5,30.6-9.5,46.8c0,16.2,3.2,32,9.5,46.8c6.1,14.3,14.7,27.2,25.8,38.2 c11,11,23.9,19.7,38.2,25.8c14.8,6.3,30.6,9.5,46.8,9.5c16.2,0,32-3.2,46.8-9.5c14.3-6.1,27.2-14.7,38.2-25.8 c11-11,19.7-23.9,25.8-38.2c6.3-14.8,9.5-30.6,9.5-46.8c0-16.2-3.2-32-9.5-46.8c-6.1-14.3-14.7-27.2-25.8-38.2 c-1.5-1.5-3-2.9-4.5-4.3l-20.8,20.8C368.2,75.5,369.7,76.9,371.2,78.4z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "red_circle_46_",
    cx: 306.9,
    cy: 59.3,
    r: 37.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWikimediaFoundation);
export default __webpack_public_path__ + "static/media/wikimedia-foundation.54590cf2.svg";
export { ForwardRef as ReactComponent };